import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';

export const IncrementButton = React.memo(({ ...props }: IconButtonProps) => {
    return (
        <InputAdornment position="end">
            <IconButton size={'small'} {...props}>
                <AddIcon />
            </IconButton>
        </InputAdornment>
    );
});
